export const MULTIPART_FORM_HEADERS = {
  "Content-Type": "multipart/form-data",
};

// Sent by edit surfaces so the backend returns the English source
// regardless of the user's UI locale. Prevents admins from overwriting
// a translation with a translated value populated into the editor.
export const SOURCE_LOCALE_HEADERS = {
  "X-Locale": "source",
} as const;
